import React from "react";
import { createRoot } from "react-dom/client";
import App from "App";
import * as serviceWorkerRegistration from "serviceWorkerRegistration";
import reportWebVitals from "reportWebVitals";
import { Provider } from "react-redux";
import persistedStore from "store";
import { PersistGate } from "redux-persist/integration/react";
//eslint-disable-next-line
import ChromeCastController from "controllers/ChromeCastController"; //required for Chromecast operation

const container = document.getElementById("root");
const root = createRoot(container);
const { store, persistor } = persistedStore();

ChromeCastController.setStore(store);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
